import { useContext, useEffect, useState } from "react";
import stateContext from "../../Context/StateContext";

export default function SelectedFontInfo() {
    const globalState = useContext(stateContext);
    const isArabic = globalState.selectedFontLanguage === "Arabic";

    const [thickness, setThickness] = useState("Classic 1.02mm");
    const [metal, setMetal] = useState("750 Yellow Gold");

    const labels = {
        en: {
            necklaceSpec: "Necklace Specification",
            width: "Width",
            height: "Height",
            selectedConfig: "Selected Configuration",
            fontStyle: "Font Style",
            metal: "Metal",
            thickness: "Thickness",
            charmStone: "Charm & Stone",
            chainStyle: "Chain Style",
            weight: "Weight",
        },
        ar: {
            necklaceSpec: "مواصفات القلادة",
            width: "عرض",
            height: "ارتفاع",
            selectedConfig: "التعديلات المختارة",
            fontStyle: "الخط",
            metal: "المعدن",
            thickness: "السماكة",
            charmStone: "التعاليق والأحجار",
            chainStyle: "السلسلة",
            weight: "وزن",
        },
    };

    const currentLabels = isArabic ? labels.ar : labels.en;

    useEffect(() => {
        if (globalState.fontThickness === 1.02) {
            setThickness("Classic 1.02mm");
        } else if (globalState.fontThickness === 1.11) {
            setThickness("Premium 1.11mm");
        }
    }, [globalState.fontThickness]);

    useEffect(() => {
        if (!globalState.selectedMetalData) return;

        setMetal(
            isArabic
                ? globalState.selectedMetalData.arabicName
                : globalState.selectedMetalData.name
        );
    }, [isArabic, globalState.selectedMetalData]);

    return (
        <div className="selected_font_info">
            <div className="necklace_info_block">
                <h4>{currentLabels.necklaceSpec}</h4>
                <div className="necklace_info">
                    <div className="configuration_row">
                        <label>{currentLabels.width}</label>
                        <span>:</span>
                        <p>
                            {(globalState.plateSize?.width / 10).toFixed(2)} cm
                        </p>
                    </div>
                    <div className="configuration_row">
                        <label>{currentLabels.height}</label>
                        <span>:</span>
                        <p>
                            {(globalState.plateSize?.height / 10).toFixed(2)} cm
                        </p>
                    </div>
                    <div className="configuration_row">
                        <label>Plate Weight</label>
                        <span>:</span>
                        <p>{globalState.textWeight.toFixed(2)} grams</p>
                    </div>
                    <div className="configuration_row">
                        <label>Total Weight</label>
                        <span>:</span>
                        <p>
                            {(
                                globalState.textWeight + globalState.chainWeight
                            ).toFixed(2)}{" "}
                            grams
                        </p>
                    </div>
                </div>
            </div>
            <div className="configuration_info_block">
                <h4>{currentLabels.selectedConfig}</h4>
                <div className="configuration_info">
                    {globalState.selectedFontData && (
                        <div className="configuration_row">
                            <label>{currentLabels.fontStyle}</label>
                            <span>:</span>
                            <p>
                                {isArabic
                                    ? globalState.selectedFontData.arabicName ||
                                      globalState.selectedFontData.name
                                    : globalState.selectedFontData.name}
                            </p>
                        </div>
                    )}

                    <div className="configuration_row">
                        <label>{currentLabels.metal}</label>
                        <span>:</span> <p>{metal}</p>
                    </div>

                    <div className="configuration_row">
                        <label>{currentLabels.thickness}</label>
                        <span>:</span> <p>{thickness}</p>
                    </div>

                    {globalState.selectedCharmData && (
                        <div className="configuration_row">
                            <label>{currentLabels.charmStone}</label>
                            <span>:</span>
                            <p>
                                {isArabic
                                    ? globalState.selectedCharmData
                                          .arabicName ||
                                      globalState.selectedCharmData.charm
                                    : globalState.selectedCharmData.charm}
                            </p>
                        </div>
                    )}

                    {globalState.selectedChainData && (
                        <div className="configuration_row">
                            <label>{currentLabels.chainStyle}</label>
                            <span>:</span>
                            <p>
                                {isArabic
                                    ? globalState.selectedChainData
                                          .arabicName ||
                                      globalState.selectedChainData.label
                                    : globalState.selectedChainData.label}
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
